import React, { useState } from 'react';
import { useApiCaller } from '../../utils/ApiUtilities';
import { getSuperAdminAdminsUrl } from '../../utils/UrlUtilities';
import { buildCreateAdminPayload } from '../../utils/PayloadUtils';

export default function AdminCreateForm({ onCreated, onCancel }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const CallApi = useApiCaller();

    const isEmailValid = (e) => /^\S+@\S+\.\S+$/.test(e);
    const isPasswordValid = (p) =>
        new RegExp(`^(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()_+\\-=[\\]{};:'",.<>/?]).{8,}$`).test(p);
    const isValid = name.trim() && isEmailValid(email) && isPasswordValid(password);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isValid) return;
        setSubmitting(true);
        const res = await CallApi({
            url: getSuperAdminAdminsUrl(),
            method: 'POST',
            payload: buildCreateAdminPayload(name.trim(), email.trim(), password),
        });
        setSubmitting(false);
        if (res.success && onCreated) {
            onCreated(res.data);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3">
                <label>Name <span className="text-danger">*</span></label>
                <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
            </div>
            <div className="mb-3">
                <label>Email <span className="text-danger">*</span></label>
                <input
                    type="email"
                    className={`form-control ${email && !isEmailValid(email) ? 'is-invalid' : ''}`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
            </div>
            <div className="mb-3">
                <label>Password <span className="text-danger">*</span></label>
                <div className="input-group">
                    <input
                        type={showPassword ? 'text' : 'password'}
                        className={`form-control ${password && !isPasswordValid(password) ? 'is-invalid' : ''}`}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowPassword(s => !s)}
                    >
                        {showPassword ? 'Hide' : 'Show'}
                    </button>
                </div>
                {password && !isPasswordValid(password) && (
                    <small className="text-danger">
                        Min 8 chars, with uppercase, digit, and special character.
                    </small>
                )}
                <small className="text-muted d-block mt-1">
                    Share this password with the admin out-of-band — it isn't shown again.
                </small>
            </div>
            <div className="d-flex gap-2">
                <button
                    type="submit"
                    className="btn btn-success"
                    disabled={!isValid || submitting}
                >
                    {submitting ? 'Creating…' : 'Create Admin'}
                </button>
                {onCancel && (
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>
                        Cancel
                    </button>
                )}
            </div>
        </form>
    );
}
